import styled, { css } from 'styled-components/macro';

export const FadingMessage = styled.span<{ $visible: boolean }>`
  transition: opacity 0.25s;
  opacity: ${props => (props.$visible ? 1 : 0)};
  ${props =>
    !props.$visible &&
    css`
      cursor: default;
    `}
`;
